import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'
import { CHECK_AUTH } from '@/store/actions.type'
import JwtService from '@/common/jwt.service'
import { MessageBox } from 'element-ui'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/admin/login/Login'),
    meta: {
      requiresAuth: false,
      title: 'ログイン'
    }
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: () => import('@/views/pages/admin/login/ForgotPassword'),
    meta: {
      requiresAuth: false,
      title: 'パスワード再設定'
    }
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => import('@/views/pages/admin/login/ResetPassword'),
    meta: {
      requiresAuth: false,
      title: 'パスワード再設定'
    }
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/pages/admin/Index'),
    redirect: 'topAdmin',
    meta: {
      requiresAuth: true,
      title: 'Home'
    },
    children: [
      {
        path: '/stationTaxAdmin',
        name: 'stationTaxAdmin',
        content: 'stationTaxAdmin',
        component: () => import('@/views/pages/admin/stationtax/ImportStationTax'),
        meta: {
          requiresAuth: true,
          title: '10秒でわかる相続税',
          permission: 'B01-01'
        }
      },
      {
        path: '/knowHowAd',
        name: 'knowHowAd',
        content: 'knowHowAd',
        component: () => import('@/views/pages/admin/11_knowhow/KnowHow'),
        meta: {
          requiresAuth: true,
          title: '読んでわかる相続',
          permission: 'B04-01'
        }
      },
      {
        path: '/knowHowAdCategory',
        name: 'knowHowAdCategory',
        content: 'knowHowAdCategory',
        component: () => import('@/views/pages/admin/11_knowhow/KnowHowCategory'),
        meta: {
          requiresAuth: true,
          title: '読んでわかる相続 カテゴリ',
          permission: 'B04-01'
        }
      },
      {
        path: '/seminar',
        name: 'seminar',
        component: () => import('@/views/pages/admin/4_seminar/Seminar'),
        meta: {
          requiresAuth: true,
          title: 'セミナー情報',
          permission: 'A03-00'
        }
      },
      {
        path: '/document/:id',
        name: 'document',
        component: () => import('../views/pages/admin/7_document/Document.vue'),
        meta: {
          requiresAuth: true,
          title: '相続税申告スケジュール',
          permission: 'C02-01'
        }
      },
      {
        path: '/hearing/:id',
        name: 'hearing',
        component: () => import('../views/pages/admin/14_hearing/Hearing.vue'),
        meta: {
          requiresAuth: true,
          title: 'ヒアリングシート',
          permission: 'Z01-01'
        }
      },
      {
        path: '/anken',
        name: 'anken',
        component: () => import('../views/pages/admin/38_anken/AnkenManage.vue'),
        meta: {
          requiresAuth: true,
          title: '案件管理',
          permission: 'Z06-01'
        }
      },
      {
        path: '/anken/:id',
        name: 'ankenDetail',
        component: () => import('../views/pages/admin/38_anken/AnkenDetail.vue'),
        meta: {
          requiresAuth: true,
          title: '案件詳細',
          permission: 'Z06-01'
        }
      },
      {
        path: '/seminar/:id/:memberId/join',
        name: 'seminarJoin',
        component: () => import('../views/pages/admin/4_seminar/SeminarJoin.vue'),
        meta: {
          requiresAuth: false,
          title: 'セミナー参加',
          permission: 'A03-03'
        }
      },
      {
        path: '/camera/:id',
        name: 'camera',
        component: () => import('../views/pages/admin/13_camera/Camera'),
        meta: {
          previous: '/anken/:id',
          requiresAuth: true,
          title: 'スマホで書類提供',
          permission: 'C03-01'
        }
      },
      {
        path: '/survey',
        name: 'survey',
        component: () => import('../views/pages/admin/18_survey/CustomerSurvey.vue'),
        meta: {
          requiresAuth: true,
          title: 'アンケート',
          permission: 'Z03-01'
        }
      },
      {
          path: '/invoiceFlagAdmin/:id',
          name: 'invoiceFlagAdmin',
          component: () => import('../views/pages/admin/6_invoice_flag/InvoiceFlag'),
          meta: {
              requiresAuth: true,
              title: '相続手続きチェックリスト',
              permission: 'C01-01'
          }
      },
      {
        path: '/emailMagazine',
        name: 'emailMagazine',
        component: () => import('../views/pages/admin/12_magazine/EmailMagazine'),
        meta: {
          requiresAuth: true,
          title: 'メルマガ',
          permission: 'Z02-01'
        }
      },
      {
          path: '/adminManagement',
          name: 'adminManagement',
          component: () => import('../views/pages/admin/99_management/AdminManagement'),
          meta: {
            requiresAuth: true,
            title: 'レガシィユーザ管理',
            permission: 'Z07-01'
          }
      },
      {
          path: '/adminManagement/role/deteals/:roleId',
          name: 'roleDetails',
          component: () => import('../views/pages/admin/99_management/RoleDetailPage'),
          meta: {
            requiresAuth: true,
            title: '設定されるロール',
            permission: 'Z07-04'
          }
      },
      {
          path: '/adminManagement/role/permissions',
          name: 'rolePermissions',
          component: () => import('../views/pages/admin/99_management/RolePermissionPage'),
          meta: {
            requiresAuth: true,
            title: 'ロール権限一覧',
            permission: 'Z07-04'
          }
      },
      {
        path: '/edit-life-event/:memberId',
        name: 'editChronology',
        component: () => import('../views/pages/admin/9_life_event/EditChronology'),
        meta: {
          requiresAuth: true,
          title: 'MY家族年表変更',
          permission: 'A02-01'
        }
      },
      {
          path: '/emergency-message',
          name: 'emergencyMessage',
          component: () => import('../views/pages/admin/emergencymessage/EmergencyMessage'),
          meta: {
              requiresAuth: true,
              title: '緊急メッセージ',
              permission: 'Z08-01'
          }
      },
      {
        path: '/chat/:id',
        name: 'chat',
        component: () => import('../views/pages/admin/17_chat/Chat'),
        meta: {
          previous: '/anken/:id',
          requiresAuth: true,
          title: 'レガシィほっとライン',
          permission: 'C05-01'
        }
      },
      {
        path: '/life-event/:memberId',
        name: 'chronology',
        component: () => import('../views/pages/admin/9_life_event/Chronology'),
        meta: {
          requiresAuth: true,
          title: 'MY家族年表',
          permission: ['A02-01', 'Z06-01']
        }
      },
      {
        path: '/customer-manage',
        name: 'customerManage',
        component: () => import('../views/pages/admin/66_customer/CustomerManage'),
        meta: {
          requiresAuth: true,
          title: '顧客管理',
          permission: 'Z05-01'
        }
      },
      {
          path: '/topAdmin',
          name: 'topAdmin',
          component: () => import('../views/pages/admin/top/TopAdmin'),
          meta: {
              requiresAuth: true,
              title: 'TOP'
          }
      },
      {
        path: '/arms/:id',
        name: 'arms',
        component: () => import('../views/pages/admin/arms/Arms'),
        meta: {
            requiresAuth: true,
            title: '案件紐づけ設定',
            permission: 'Z06-01'
        }
      },
      {
        path: '/new-life-event',
        name: 'newLifeEvent',
        component: () => import('../views/pages/admin/9_life_event/NewLifeEvent'),
        meta: {
            requiresAuth: true,
            title: 'ライフイベント',
            permission: 'A02-03'
        }
      },
      {
        path: '/manage-documents',
        name: 'manage-documents',
        component: () => import('../views/pages/admin/download/Documents'),
        props: (route) => ({
          ...route.params
        }),
        meta: {
          requiresAuth: true,
          title: '資料ダウンロード一覧',
          permission: 'Z08-01'
        }
      },
      {
        path: '/manage-document-categories',
        name: 'manage-document-categories',
        component: () => import('../views/pages/admin/download/Categories'),
        meta: {
          requiresAuth: true,
          title: '資料ダウンロードカテゴリ',
          permission: 'Z08-01'
        }
      },
      {
        path: '/manage-document-downloaded',
        name: 'manage-document-downloaded',
        component: () => import('../views/pages/admin/download/DownloadedDocument'),
        meta: {
          requiresAuth: true,
          title: '資料ダウンロード状況確認',
          permission: 'Z08-01'
        }
      },
      {
        path: '/heritageDivision/:id',
        name: 'heritageDivision',
        component: () => import('../views/pages/admin/16_heritagedivision/HeritageDivisionPage'),
        meta: {
          requiresAuth: true,
          title: '遺産分割シミュレーション',
          permission: 'C04-01'
        }
      },
      {
        path: '/messageDetail/:id',
        name: 'messageDetail',
        component: () => import('../views/pages/admin/emergency_message_detail/MessageDetail.vue'),
        meta: {
          requiresAuth: true,
          title: 'メッセージ詳細'
        }
      },
      {
        path: '/reportDocument/:id',
        name: 'reportDocument',
        component: () => import('../views/pages/admin/report/ReportUpload.vue'),
        meta: {
          requiresAuth: true,
          title: '顧客へ書類提供'
        }
      },
      {
        path: '/maintenance',
        name: 'maintenance',
        component: () => import('../views/pages/admin/maintenance/Maintenance.vue'),
        meta: {
          requiresAuth: false,
          title: 'メンテナンス中'
        }
      }
    ]
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: () => import('@/views/pages/error-page/404')
  }
]

const checkPermission = (to) => {
  if ('meta' in to) {
	let hasPermissionCheck = false
    if ('permissionGroup' in to.meta) {
      hasPermissionCheck = true
      if (Vue.prototype.$perm.hasGroup(to.meta.permissionGroup)) return true
    }
    if ('permission' in to.meta) {
      hasPermissionCheck = true
      if (Vue.prototype.$perm.has(to.meta.permission)) return true
    }
    if (hasPermissionCheck) return false
  }
  return true
}

const getNextPath = (route) => {
  let nextPath = '/topAdmin'
  const regex = /:[\w]+/g
  if (route.meta.previous) {
    nextPath = route.meta.previous
    for (const match of route.meta.previous.matchAll(regex)) {
      let pathVariableName = match[0].slice(1)
      nextPath = nextPath.replaceAll(match[0], route.meta[pathVariableName] || route.params[pathVariableName]) // get next path variable value from previous route meta or path variable
    }
  }

  return nextPath
}

VueRouter.prototype.getNextPath = getNextPath

const getRoute = () => {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })

  router.beforeEach((to, from, next) => {
    store.dispatch(CHECK_AUTH).then(() => {
      // const loggedIn = localStorage.getItem('id_token')
      document.title = to.meta.title
      if (to.path !== '/login' &&
          to.path !== '/forgotPassword' &&
          to.path !== '/resetPassword' &&
          to.path !== '/maintenance'
      ) {
        if (JwtService.getToken() && checkPermission(to)) {
          next()
        } else {
          next({
            path: '/login',
            query: {
              redirect: to.fullPath
            }
          })
        }
      } else {
        if (to.path === '/login' && store.getters.isAuthenticated) {
          next({
            path: getNextPath(from)
          })
        } else {
          next()
        }
      }
    })
  })

  router.onError(error => {
	// ChunkLoadError: Loading chunk chunk-29fdd11d failed.
    if (/loading chunk chunk-\w* failed./i.test(error.message)) {
      MessageBox({
        title: '最新バージョンを検出したため、リロードを行います。',
        showClose: false,
        center: true
      }, () => { window.location.reload(true) })
    }
  })

  return router
}

export default getRoute
